'use client';

import classes from './Title.module.scss';
import { useDictionary } from '@/src/dictionaries/dictionary-provider';

export const Title = ({ title }: { title: string }) => {
  const dictionary = useDictionary();

  return (
    <div className={classes.titleWrapper}>
      <h1 className={classes.sectionTitle}>{title}</h1>
      <img
        src={dictionary.separateur}
        alt="Separation"
        className={`${classes.horizontalSectionDivider} mb-5`}
      />
    </div>
  );
};
